import request from '@/utils/request';

const BASEURL = process.env.VUE_APP_GOOGLE_BASEURL;

const POST = (url, data, config) =>
  request({
    url,
    baseURL: BASEURL,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    transformRequest: [
      function (data) {
        return JSON.stringify(data);
      },
    ],
    ...config,
  });

const GET = (url, params, config) =>
  request({
    url,
    baseURL: BASEURL,
    method: 'get',
    params,
    ...config,
  });

/** 账户异常主列表（可见账户 + 自己授权邮箱里的邮件） */
export const getAlertAccountPage = (params) => POST('/gmail/alert/accountPage', params);

/** 账户异常抽屉：时间线 + 证据邮件 */
export const getAlertAccountDetail = (params) => GET('/gmail/alert/accountDetail', params);

/** 证据邮件正文 */
export const getAlertMailDetail = (params) => GET('/gmail/alert/mailDetail', params);

/** 授权邮箱：独立 GMAIL OAuth 应用 */
export const getGmailAuthUrl = (params) => GET('/auth/getAuthUrl', { oauthClientType: 'GMAIL', ...params });

/** 当前用户邮箱是否正在监听 */
export const getMailboxWatch = () => GET('/gmail/alert/mailboxWatch');

/** 邮件流水：可见账户上的证据邮件，一封信多个账户拆成多行 */
export const getMailFlowPage = (params) => POST('/gmail/alert/mailFlow', params);

/** 未挂账户：录入人可见、正文没有客户 ID 的邮件 */
export const getOrphanPage = (params) => POST('/gmail/alert/orphanPage', params);

/** 为当前用户写入演示数据，已有则跳过 */
export const seedDemo = () => POST('/gmail/alert/seedDemo', {});
